// PreviewTester/utils/templateParser.js
import { getInverseCondition, buildElseCondition } from './valueGenerator';

// Extract nested conditions from template
export const extractNestedConditions = (templateText) => {
  console.log('[DEBUG] extractNestedConditions called with template:', templateText);
  const lines = templateText.split('\n');
  const rootBlocks = [];
  const blockStack = [];
  let inElseBlock = false;
  let currentElseBlock = null;
  
  // Track conditions per nesting level for building else conditions
  let chainConditionsByLevel = {};

  console.log('[DEBUG] extractNestedConditions - processing lines');

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    console.log('[DEBUG] extractNestedConditions - line ' + i + ':', line);

    const ifMatch = line.match(/\{%\s*if\s+([^%]+)\s*%\}/);
    if (ifMatch) {
      const condition = ifMatch[1].trim();
      console.log('[DEBUG] extractNestedConditions - found IF at line ' + i + ' with condition:', condition);

      // Start a new chain for this nesting level
      chainConditionsByLevel[blockStack.length] = [condition];

      const newBlock = {
        type: 'block',
        condition: condition,
        allConditions: [condition],
        conditions: [{ type: 'if', condition, line: i }],
        children: [],
        elifConditions: [],
        hasElse: false,
        elseBlock: null,
        depth: blockStack.length,
        isElif: false,
        isElseBlock: false
      };

      if (inElseBlock && currentElseBlock) {
        currentElseBlock.children.push(newBlock);
        console.log('[DEBUG] extractNestedConditions - added as child to elseBlock');
      } else if (blockStack.length === 0) {
        rootBlocks.push(newBlock);
        console.log('[DEBUG] extractNestedConditions - added to rootBlocks');
      } else {
        const parent = blockStack[blockStack.length - 1];
        parent.children.push(newBlock);
        console.log('[DEBUG] extractNestedConditions - added as child to parent:', parent.condition);
      }

      blockStack.push(newBlock);
      console.log('[DEBUG] extractNestedConditions - blockStack depth:', blockStack.length);
      continue;
    }

    const elifMatch = line.match(/\{%\s*elif\s+([^%]+)\s*%\}/);
    if (elifMatch) {
      const condition = elifMatch[1].trim();
      console.log('[DEBUG] extractNestedConditions - found ELIF at line ' + i + ' with condition:', condition);

      // Add this condition to the chain for current nesting level
      const currentLevel = blockStack.length - 1;
      if (!chainConditionsByLevel[currentLevel]) {
        chainConditionsByLevel[currentLevel] = [];
      }
      chainConditionsByLevel[currentLevel].push(condition);

      if (blockStack.length > 0) {
        const currentBlock = blockStack[blockStack.length - 1];
        currentBlock.elifConditions.push(condition);
        currentBlock.allConditions.push(condition);
        currentBlock.conditions.push({ type: 'elif', condition, line: i });
      }
      continue;
    }

    const elseMatch = line.match(/\{%\s*else\s*%\}/);
    if (elseMatch && blockStack.length > 0) {
      console.log('[DEBUG] extractNestedConditions - found ELSE at line ' + i);

      const parentBlock = blockStack[blockStack.length - 1];
      if (parentBlock) {
        parentBlock.hasElse = true;
        parentBlock.conditions.push({ type: 'else', line: i });
        console.log('[DEBUG] extractNestedConditions - parent hasElse set to true');
        inElseBlock = true;

        // Get chain conditions for this level
        const currentLevel = blockStack.length - 1;
        const chainConditions = chainConditionsByLevel[currentLevel] || [parentBlock.condition];
        
        console.log('[BUG_ELSE_DISPLAY] 🔍 Chain conditions for else:', JSON.stringify(chainConditions));
        
        const elseCondition = buildElseCondition(chainConditions);
        console.log('[BUG_ELSE_DISPLAY] 🔍 Built else condition:', elseCondition);

        const elseBlock = {
          type: 'elseblock',
          condition: elseCondition,
          conditions: [{ type: 'else', condition: elseCondition, line: i }],
          children: [],
          elifConditions: [],
          hasElse: false,
          elseBlock: null,
          depth: parentBlock.depth + 1,
          isElseBlock: true,
          parentCondition: parentBlock.condition,
          isElif: false
        };

        console.log('[BUG_ELSE_DISPLAY] 🔍 Created elseBlock:', JSON.stringify(elseBlock, null, 2));
        parentBlock.elseBlock = elseBlock;
        currentElseBlock = elseBlock;

        // FIX: For root-level else, add to rootBlocks as a sibling
        if (parentBlock.depth === 0) {
          console.log('[DEBUG] extractNestedConditions - root-level ELSE, adding to rootBlocks');
          // Add else as a root-level sibling
          rootBlocks.push(elseBlock);
          // Push to stack so nested conditions inside else are handled correctly
          blockStack.push(elseBlock);
        }
      }
      continue;
    }

    const endifMatch = line.match(/\{%\s*endif\s*%\}/);
    if (endifMatch && blockStack.length > 0) {
      console.log('[DEBUG] extractNestedConditions - found ENDIF at line ' + i);

      const popped = blockStack.pop();
      console.log('[DEBUG] extractNestedConditions - popped from stack:', popped);

      // Clear chain conditions for the level we just exited
      const exitedLevel = blockStack.length;
      delete chainConditionsByLevel[exitedLevel];

      if (inElseBlock && currentElseBlock) {
        const elseDepth = currentElseBlock.depth;
        if (blockStack.length <= elseDepth) {
          console.log('[DEBUG] extractNestedConditions - exiting else block');
          inElseBlock = false;
          currentElseBlock = null;
        }
      }
    }
  }

  console.log('[DEBUG] extractNestedConditions - rootBlocks:', JSON.stringify(rootBlocks, null, 2));
  return rootBlocks;
};